export const NotFoundPage = {
  title: 'Page not found',
  description: 'The address may be mistyped, or the page may have moved. Go to the home page, or contact us if you were looking for something specific.',
  homeLinkLabel: 'Go to the home page',
  contactLinkLabel: 'Contact us',
};